// extracted by mini-css-extract-plugin
module.exports = {"industries":"page_industries__5upO_","industries_cardsContainer":"page_industries_cardsContainer__DDSex"};